import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import "./Categories.css";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import riyalSymbol from "./images/riyal_symbol.svg";
import { useTranslation } from "react-i18next";

function Payment() {
  const { t, i18n } = useTranslation("backend");
  const [packages, setPackages] = useState([]);
  const [packagesUser, setPackagesUser] = useState([]);
  // const [selectedPlan, setSelectedPlan] = useState(null);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = Cookies.get("token");
  const [isAdmin, setIsAdmin] = useState(false);

  // Fetch packages from the backend
  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
      setIsAdmin(decodedToken.isAdmin);
      // userEmail = decodedToken.email;
    }
    const fetchPackages = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/plans/admin`);
        if (!response.ok) throw new Error("Failed to fetch packages");
        const data = await response.json();
        setPackages(data);
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };
    fetchPackages();

    const Packages = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/plans`);
        if (!response.ok) throw new Error("Failed to fetch packages");
        const data = await response.json();
        setPackagesUser(data);
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };
    Packages();
  }, [BASE_URL]);

  const handleDelete = async (plan_name) => {
    const isConfirmed = window.confirm(t("deleteConfirmation"));

    if (isConfirmed) {
      try {
        const response = await fetch(`${BASE_URL}/api/plans/${plan_name}`, {
          method: "DELETE",
        });

        if (!response.ok) {
          throw new Error(`Failed to delete plan. Status: ${response.status}`);
        }

        alert(t("deleteSuccess"));
        setPackages((prevPlans) => {
          const updatedPlans = prevPlans.filter(
            (plan) => plan.plan_name !== plan_name
          );
          return updatedPlans;
        });
      } catch (error) {
        console.error("Delete error:", error);
        alert("There was an error deleting the plan.");
      }
    }
  };

  return (
    <div className="product-container">
      {isAdmin ? (
        <div className="admin-content">
          <h2>{t("admin_controls")}</h2>
          <Link to="/dashboard/create-pkg">
            <button className="create-package-button">
              {t("create_new_pkg")}
            </button>
          </Link>
          <div className="table-container">
            <table className="package-table">
              <thead>
                <tr>
                  <th>{t("plans")}</th>
                  <th>{t("amount")}</th>
                  <th>{t("duration")}</th>
                  <th>{t("status")}</th>
                  <th>{t("action")}</th>
                </tr>
              </thead>
              <tbody>
                {packages.map((pkg) => (
                  <tr key={pkg.id}>
                    <td>
                      {i18n.language === "ar"
                        ? pkg.plan_name_ar
                        : pkg.plan_name}
                    </td>
                    <td>
                      <img src={riyalSymbol} height={"30px"} alt="riyal"></img> {pkg.amount}{" "}
                    </td>
                    <td>{pkg.duration}</td>
                    <td>
                      <span className={`status ${pkg.status.toLowerCase()}`}>
                        {pkg.status.charAt(0).toUpperCase() +
                          pkg.status.slice(1)}
                      </span>
                    </td>
                    <td>
                      <Link
                        to="/dashboard/plans-edit"
                        onClick={() =>
                          localStorage.setItem("plan_name", pkg.plan_name)
                        }
                      >
                        <button className="edit-button edit">
                          <FaEdit />
                        </button>
                      </Link>

                      <button
                        className="delete-button red"
                        onClick={() => handleDelete(pkg.plan_name)}
                      >
                        <FaTrashAlt />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <>
          <h2>{t("products")}</h2>
          <div className="product-boxes">
            {packagesUser.map((pkg) => (
              <div className="product-boxes-container">
                <div className="product-box" key={pkg.id}>
                  <h1>
                    {i18n.language === "ar" ? pkg.plan_name_ar : pkg.plan_name}
                  </h1>
                  <div className="inside-product-box">
                    <h3>
                      <img src={riyalSymbol} height={"30px"} alt="riyal"></img> {pkg.amount}{" "}
                    </h3>
                    <h4>{pkg.duration} Months</h4>
                    {pkg.features &&
                      Array.isArray(pkg.features) &&
                      pkg.features.map((feature, index) => (
                        <p key={index}>
                          {i18n.language === "ar"
                            ? feature.text_ar
                            : feature.text}
                        </p>
                      ))}
                    <Link
                      to="/dashboard/payments"
                      state={{ selectedPlan: pkg }}
                    >
                      <button>{t("buy_now")}</button>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default Payment;
